import React, { useMemo } from 'react';
import { getNumbers, useTokenValues } from '@jds/react-engine';

import { JDSStepperDotProps } from './generated/interface';

export const withLogic =
  (
    Component: React.ComponentType<JDSStepperDotProps>
  ): React.FC<JDSStepperDotProps> =>
  (props: JDSStepperDotProps) => {
    const tokens = useTokenValues();
    const language = tokens.lang;
    const numeralList = useMemo(() => {
      return getNumbers(language);
    }, [language]);

    return (
      <Component {...props} index={numeralList[Number(props.index ?? 0)]} />
    );
  };
